/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".logo-container[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{max-width:100px}header[_ngcontent-%COMP%]{width:100%}header.header-background[_ngcontent-%COMP%]{background:linear-gradient(153.43deg,#eb1c31 0,#48276c 100%)}.menu-container[_ngcontent-%COMP%]{margin-left:auto}@media (max-width:767.98px){.menu-container[_ngcontent-%COMP%]{display:none}}.menu-container[_ngcontent-%COMP%]   a.menu-item[_ngcontent-%COMP%]{color:#fff;text-decoration:none}"];
export { styles as styles };
